export const navItems = [
  {
    category: "Overview",
    iClass: "bi bi-bullseye",
    url: "/sales-admin"
  },
  {
    category: "Agents",
    iClass: "bi bi-people-fill",
    url: "/sales-admin/agents"
  },
  {
    category: "Merchants",
    iClass: "bi bi-shop",
    url: "/sales-admin/merchants"
  },
  {
    category: "Feedbacks",
    iClass: "bi bi-chat-left-text",
    url: "/sales-admin/feedbacks"
  },
  {
    category: "Referral Code",
    iClass: "bi bi-share-fill",
    url: "/sales-admin/referral"
  },
  {
    category: "Settings",
    iClass: "bi bi-gear-fill",
    url: "/sales-admin/settings"
  },
];
